import React from 'react';

// Disabed continuous popup as requested by platform administrator
export default function ApologyModal() {
  return null;
}
